import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
// Hooks
import { usePortal } from 'modules/core/lib/portalContext'

import useOverlimitEmployeesChecker from 'modules/employees/components/OverlimitEmployees/useOverlimitEmployeesChecker'

interface Props {
  setUpgradeModalOpen: (value: boolean) => void
}

const OverlimitEmployeesFootNote = ({ setUpgradeModalOpen }: Props) => {
  const { closePortal } = usePortal()

  const { isOverlimit, currentSeats, limitEmployeesCurrentPlan } = useOverlimitEmployeesChecker()
  if (!isOverlimit) return null

  const onClick = () => {
    closePortal({
      preventOnCloseCallbackAfterClose: true,
    })

    setUpgradeModalOpen(true)
  }

  return (
    <Box flexDirection="row" alignItems="flexStart" gap="s8">
      <Box>
        <Icon.Medium icon="upgrade-plan" color="champagne1000" />
      </Box>
      {i18n.tView('overlimit_employees.foot_note.message', {
        currentSeats: <span>{currentSeats}</span>,
        limitEmployeesCurrentPlan: <span>{limitEmployeesCurrentPlan}</span>,

        upgradeLink: (
          <span style={{ cursor: 'pointer' }} role="button" onClick={onClick}>
            <Text.Normal color="champagne1000" underlined>
              {i18n.t('overlimit_employees.foot_note.link_text')}
            </Text.Normal>
          </span>
        ),
      })}
    </Box>
  )
}

export default observer(OverlimitEmployeesFootNote)
